"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GustoCallbackPayloadStateSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const base_callback_state_interface_1 = require("./base-callback-state.interface");
exports.GustoCallbackPayloadStateSchema = zod_1.default.object(base_callback_state_interface_1.BaseCallbackPayloadState);
